import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import React from "react";

export default function Note({ children }: { children?: React.ReactNode }) {
  return <div sx={boardNoteStyle}>{children}</div>;
}

const boardNoteStyle: ThemeUIStyleObject = {
  marginTop: RAW_cssValue("10px"),
  display: "flex",
  alignItems: "center",
  flexDirection: "row",
};
